<template>
	<ValidationProvider
		v-slot="{ errors, ariaMsg }"
		ref="validationProvider"
		tag="div"
		class="text-input-wrap mb-10"
		mode="eager"
		:name="name"
		:rules="{ required, isValidPhone: { isValid: isValidPhone } }"
	>
		<label v-if="!isHiddenLabel" class="text-input-label">
			<span>{{ label }}</span>
			<slot name="right-label" />
		</label>
		<div class="text-input-holder">
			<VueTelInput
				class="text-input"
				:value="innerValue"
				:class="{ validError: errors[0], 'hide-countries-list': !region.isEU && !region.isROW }"
				:disabled="disabled"
				:input-options="{ id: name, name, placeholder, maxlength: 18 }"
				:auto-default-country="region.isEU || region.isROW"
				:preferred-countries="region.isUS ? ['us'] : region.isUK ? ['gb'] : region.isAU ? ['au'] : []"
				@input="updateValue"
				@focus="focused = true"
				@blur="focused = false"
			/>
			<div v-if="errors[0]" class="text-input-errors">
				<span v-if="errors[0]" v-bind="ariaMsg">
					{{ errors[0] }}
				</span>
			</div>
		</div>
	</ValidationProvider>
</template>

<script>
import { mapGetters } from 'vuex'
import { ValidationProvider } from 'vee-validate'
import { VueTelInput } from 'vue-tel-input'
import 'vue-tel-input/dist/vue-tel-input.css'

export default {
	name: 'PhoneInput',
	components: { VueTelInput, ValidationProvider },
	props: {
		label: {
			type: String,
			default: ''
		},
		name: {
			type: String,
			default: ''
		},
		countryCode: {
			type: String,
			required: false,
			default: null
		},
		value: {
			type: String,
			default: ''
		},
		placeholder: {
			type: String,
			default: ''
		},
		disabled: {
			type: Boolean,
			default: false
		},
		required: {
			type: Boolean,
			default: false
		},
		isHiddenLabel: {
			type: Boolean,
			default: false
		}
	},
	data () {
		return {
			innerValue: '',
			formattedPhone: '',
			focused: false,
			isValidPhone: false,
			countryCallingCode: ''
		}
	},
	computed: {
		...mapGetters({ region: 'user/region' })
	},
	watch: {
		value: {
			immediate: true,
			handler (val) {
				this.innerValue = val || ''
			}
		}
	},
	methods: {
		updateValue (value, phoneEvent) {
			const phoneNum = phoneEvent.number
				? phoneEvent.formatted.includes(' ')
					? phoneEvent.formatted
					: phoneEvent.number
				: value

			this.$emit('input', phoneNum)

	  this.isValidPhone = this.disabled || Boolean(phoneEvent.valid)
		}
	}
}
</script>

<style lang="scss">
	.vue-tel-input {
		height: 45px;
		border: none;
		border-radius: 0;
		&:focus-within {
			border-color: initial;
			box-shadow: none;
		}
		&.text-input {
			padding: 0;
		}
		&.hide-countries-list .vti__dropdown {
			display: none;
		}

		.vti__dropdown-list {
			width: 236px;
		}
		.vti__dropdown-list.below {
			top: 40px;
		}
		.vti__dropdown {
			background-color: $white;
			.vti__dropdown-item strong {
				font-weight: 400;
			}
		}
		&.validError {
			border: 1px solid $red;
		}
	}
</style>
